module.exports = __webpack_public_path__ + "img/in-use-christine-waterman@2x.26251f3f.jpg";